(function () {
    'use strict';

    function InvoiceInfoListComponentController(__config, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, InvoiceInfoCustom, $translate) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.__config = __config;
        $ctrl.findStatusStyle = findStatusStyle;
        $ctrl.findStatusTitle = findStatusTitle;

        $ctrl.editInvoiceInfo = editInvoiceInfo;


        loadAll();
        loadPage();

        function loadAll() {


        }

        function loadPage() {
            translatePartialLoader.addPart('invoiceStatus');
            translatePartialLoader.addPart('customer');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('customerStatus');
            translatePartialLoader.addPart('invoiceInfo');
            translatePartialLoader = translate.refresh();
        }


        function findStatusStyle(status) {
            return "invoice-info-status-box invoice-status-" + status;
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function editInvoiceInfo(invoiceInfo) {
            if (invoiceInfo.status == 'TEMP')
                $state.go('supplierPanel-v2.companyCustomer.editInvoiceInfo', {id: invoiceInfo.id});
            if (invoiceInfo.status == 'UNPAID' || invoiceInfo.status == 'SETTLEMENT' || invoiceInfo.status == 'VOID')
                $state.go('supplierPanel-v2.companyCustomer.invoiceInfoDetail', {id: invoiceInfo.id});

        }
    }

    var InvoiceInfoListComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/invoice-info-list/partial-form.invoice-info-list.html',
        controller: InvoiceInfoListComponentController,
        bindings:
            {
                invoiceInfoList: '=',
                fromDate: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfInvoiceInfoList', InvoiceInfoListComponent)

    InvoiceInfoListComponentController.$inject = ['__config', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'InvoiceInfoCustom', '$translate'];


})();

